import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "./styles.scss";
import Nav from "./Nav";
import Footer from "./Footer";
import FinalCta from "./FinalCta";
import { AGENTS, AgentCard, AgentsHero } from "./agents-data";

function useHashScroll() {
  const loc = useLocation();
  useEffect(() => {
    if (!loc.hash) return;
    const el = document.getElementById(loc.hash.replace("#", ""));
    if (el) requestAnimationFrame(() => window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 80, behavior: "smooth" }));
  }, [loc.hash, loc.pathname]);
}

export default function AgentsPage() {
  useHashScroll();
  return (
    <div className="ai-root min-h-screen" data-screen-label="EkkBaz AI · Agents">
      <Helmet>
        <title>AI Agents — EkkBaz AI | 11 Purpose-Built Self-Learning Agents</title>
        <meta name="description" content="Eleven production-grade AI agents: WhatsApp Commerce, AR Collections, Supplier Onboarding, CX Concierge, Demand Forecast, Salesforce Automation, Inventory Intelligence, Warehouse Ops, Delivery & Logistics, Distributor Management, Embedded Financing." />
        <link rel="canonical" href="https://ekkbaz.ai/agents" />
        <meta property="og:title" content="AI Agents — EkkBaz AI | 11 Purpose-Built Self-Learning Agents" />
        <meta property="og:description" content="Browse 11 production-ready AI agents that automate every major B2B operational function. Each agent learns from outcomes and improves continuously." />
        <meta property="og:url" content="https://ekkbaz.ai/agents" />
        <meta property="og:image" content="https://ekkbaz.ai/assets/images/ekkbaz-og.png" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          "url": "https://ekkbaz.ai/agents",
          "name": "EkkBaz AI — Agent Catalog",
          "description": "Eleven purpose-built, self-learning AI agents covering every major operational function for B2B enterprises.",
          "isPartOf": {"@id": "https://ekkbaz.ai/#website"},
          "about": {"@id": "https://ekkbaz.ai/#platform"}
        })}</script>
      </Helmet>
      <Nav />
      <main>
        <AgentsHero />
        {AGENTS.map(a => <AgentCard key={a.id} a={a} />)}
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}
